import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { initLiff } from "./lib/liff";
import { AdminPage } from "./pages/AdminPage";
import { HomePage } from "./pages/HomePage";
import { MyReservationsPage } from "./pages/MyReservationsPage";
import { ReservationConfirmPage } from "./pages/ReservationConfirmPage";
import { ReservationDonePage } from "./pages/ReservationDonePage";
import { ReservationNewPage } from "./pages/ReservationNewPage";

export function App() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    initLiff()
      .then(() => setReady(true))
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  if (error) {
    return (
      <div className="flex min-h-full items-center justify-center p-6">
        <div className="max-w-sm text-center">
          <p className="text-sm font-semibold text-red-600">LIFF の初期化に失敗しました</p>
          <p className="mt-2 break-all text-xs text-neutral-500">{error}</p>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="flex min-h-full items-center justify-center">
        <p className="text-sm text-neutral-500">読み込み中…</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/reservation/new" element={<ReservationNewPage />} />
      <Route path="/reservation/confirm" element={<ReservationConfirmPage />} />
      <Route path="/reservation/done" element={<ReservationDonePage />} />
      <Route path="/reservations" element={<MyReservationsPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}
